import type { Tag } from 'app/network/listing';

const OTHER_TAG_NAMES = new Set(['autre', 'autres', 'other', 'others', 'otro', 'otros', 'otra', 'otras']);

export function moveOtherTagToEnd(tags: Tag[]) {
  const isOtherTag = (tag: Tag) => OTHER_TAG_NAMES.has(tag.tagName.trim().toLowerCase());

  return [...tags.filter((tag) => !isOtherTag(tag)), ...tags.filter(isOtherTag)];
}
